import { type Enum } from '@webapp/infrastructure/types/Enum'

// Match confirmation state. Only CONFIRMED matches render on the Matched
// tab and count toward the cleared balance / Submit gating.
export const ReconcileMatchStatuses = {
  SUGGESTED: 0, // System-suggested match
  CONFIRMED: 1, // User-confirmed match
} as const

export type ReconcileMatchStatus = Enum<typeof ReconcileMatchStatuses>
